const types = {
  IS_LOADING_DASHBOARD: "IS_LOADING_DASHBOARD",
  UPDATE_DASHBOARD_DATA: "UPDATE_DASHBOARD_DATA",
};

export default types;
